import React from "react";

interface IProps extends React.HTMLAttributes<HTMLHeadingElement> {
  level: Level;
  children: React.ReactChildren | string;
}

type Level = "h1" | "h2" | "h3" | "h4";

const Title: React.FC<IProps> = ({ level, children, ...props }) => {
  switch (level) {
    case "h1":
      return <h1 {...props}>{children}</h1>;
    case "h2":
      return <h2 {...props}>{children}</h2>;
    case "h3":
      return <h3 {...props}>{children}</h3>;
    case "h4":
      return <h4 {...props}>{children}</h4>;
    default:
      return <h1 {...props}>{children}</h1>;
  }
};

export default Title;
